import React from 'react';
import {inject, observer} from 'mobx-react';

import E9ToolBar from './E9ToolBar';
import E9ToolBarMore from './E9ToolBarMore';
import E9Account from './E9Account';

@inject('portalThemeStore')
@observer
class E9HeaderRight extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {portalThemeStore} = this.props;
        const {pluginReload} = portalThemeStore;
        if (pluginReload) {
            portalThemeStore.getPlugins();
        }
    }
    componentDidUpdate() {
        const logo= $('.e9header-left').width();
        const rleft=$('.e9header-right-menu').width();
        const rright=$('.e9header-right-toolbar').width();
        const topswitch=$('.e9header-switch').width();
        const wid=logo+rleft+rright+topswitch+30;  
        $('.e9theme-layout-container').css({'min-width':wid+'px'});
        $('.e9theme-layout2-container').css({'min-width':wid+'px'});
        $('.e9theme-layout3-container').css({'min-width':wid+'px'});
        $('.e9theme-layout4-container').css({'min-width':wid+'px'});
    }

    render() {
        const {portalThemeStore} = this.props;
        const {pluginIds = [], pluginInsertCount} = portalThemeStore;

        return (
            <div className="e9header-right-toolbar">
                {
                    pluginIds.map((item, index) => {
                        return <div key={index} id={item} className="e9header-toolbar-plugin"/>;
                    })
                }
                {pluginInsertCount > 0 ?  <div className="e9header-toolbar-splitter"/> : null}
                <E9ToolBar {...this.props} />
                <E9ToolBarMore {...this.props} />
                <div className="e9header-toolbar-splitter"/>
                <E9Account {...this.props} />
            </div>
        );
    }
}

export default E9HeaderRight;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9HeaderRight.js